import PropTypes from 'prop-types';

import { FLOW_CATEGORIES } from 'Pages/TeamDashboard/ProductLibrary/flowCategories';

import FlowDropdown from './FlowDropdown';

const SubFlowDropdown = ({ categoryName, value, onChange, disabled }) => {
  const category = FLOW_CATEGORIES.find(cat => cat.name === categoryName);
  const subFlows = category?.flows || [];

  return (
    <FlowDropdown
      value={value}
      onChange={onChange}
      items={subFlows}
      placeholder="Select sub-flow"
      triggerSize="small"
      disabled={disabled}
      heading={categoryName}
    />
  );
};

SubFlowDropdown.propTypes = {
  categoryName: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

SubFlowDropdown.defaultProps = {
  categoryName: '',
  value: '',
  disabled: false,
};

export default SubFlowDropdown;
